import * as z from "zod";

const idNameSchema = z.object({ id: z.string(), name: z.string() });

export const processingPipelineMerchantRowSchema = z.object({
  id: z.string(),
  name: z.string(),
  /** Delivered, awaiting processing, ≤3 business days old. */
  withinSla: z.number(),
  /** Delivered, awaiting processing, 4–7 business days old. */
  overSla: z.number(),
  /** Delivered, awaiting processing, 8+ business days old. */
  critical: z.number(),
  /** Delivered, awaiting processing, with no delivered_at to age by. */
  undated: z.number(),
  total: z.number(),
});

export type ProcessingPipelineMerchantRow = z.infer<
  typeof processingPipelineMerchantRowSchema
>;

export const getProcessingPipeline = {
  name: "getProcessingPipeline" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    teamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    /** The operator team's returns center(s), for the header / RC selector. */
    returnsCenterOptions: z.array(idNameSchema),
    /** In-transit returns toward the scoped RC(s) — context card, not backlog. */
    inTransitCount: z.number(),
    /** All delivered-but-unprocessed returns in the scoped RC(s). */
    awaitingTotal: z.number(),
    /** Awaiting and aged past the SLA target (4+ business days). */
    overTargetTotal: z.number(),
    /** Awaiting and critically aged (8+ business days). */
    criticalTotal: z.number(),
    /** Over-target count as a rounded % of awaiting; null when none awaiting. */
    overTargetShare: z.number().nullable(),
    /** Critical count as a rounded % of awaiting; null when none awaiting. */
    criticalShare: z.number().nullable(),
    merchants: z.array(processingPipelineMerchantRowSchema),
    /** Every merchant with returns in the pipeline, for the filter dropdown. */
    merchantOptions: z.array(idNameSchema),
    /** Server time the snapshot was computed (ISO) — drives the freshness label. */
    generatedAt: z.string(),
  }),
};

export type GetProcessingPipelineOutput = z.infer<
  (typeof getProcessingPipeline)["output"]
>;
